import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import statueImg from '../images/statueImg.jpg';
import mandir2 from '../images/mandir2.jpg';
import Carousel from 'react-bootstrap/Carousel';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import '../index.css'
import { useNavigate } from 'react-router-dom';

export default function About() {
  const [imgSlider, setimgSlider] = useState([]);
  const [aboutData, setaboutData] = useState([]);
  const navigate = useNavigate()

  const imgArry = [
    {
      cap1: 'First slide label',
      cap2: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
      img: mandir2,
    },
    {
      cap1: 'Second slide label',
      cap2: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      img: mandir2,
    },
    {
      cap1: 'Third slide label',
      cap2: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur.',
      img: mandir2,
    },
  ];

  useEffect(() => {
    setimgSlider(imgArry);
    homeData();
    scrollToTop();
  }, []);

  const homeData = async () => {
    try {
      const response = await fetch("https://api.padampura.com/AboutUs");
      const result = await response.json();
      if (result.status === true) {
        setaboutData(result.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sanitizeHtml = (html) => {
    return html ? html.replace(/<\/?p>/g, '') : '';
  };

  return (
    <div>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>About Us | Padampura Jain Trust</title>
        <meta name="description" content="Learn about Lord Padamprabhu Ji, the origin of the divine statue, and the history of Padampura Jain Trust. Explore spiritual roots and heritage." />
        <meta name="keywords" content="Padampura, Lord Padamprabhu Ji, Jain Mandir, Jain Statue Origin, Jain Trust, About Padampura, Jain History" />
        <meta property="og:title" content="About Us | Padampura Jain Trust" />
        <meta property="og:description" content="Discover the origin of Lord Padamprabhu Ji’s statue and the story behind the Padampura Jain Trust." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://padampura.com/About" />
        <meta property="og:image" content="https://padampura.com/Swastik.png" />
        <link rel="canonical" href="https://padampura.com/" />
      </Helmet>

      {/* Page Content */}
      <div className='container-fluid g-0 mt-5'>
        <div className='row'>
          <div className='col-12'>
            <Carousel>
              {imgSlider.map((item, index) => (
                <Carousel.Item key={index}>
                  <img src={item.img} alt="padampura" style={{ width: '100%', height: "70vh", objectFit: 'cover' }} />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      <div className='container mt-3'>
        <p className='text-center text-decoration-underline' style={{ fontFamily: "Poppins", fontSize: "2em", color: "#000", fontWeight: 500 }}>ABOUT</p>
        <div className='row'>
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <img src={statueImg} style={{ width: "100%", objectFit: "cover" }} alt="Statue" />
          </div>
          <div className='col-lg-8 col-md-6 col-sm-12'>
            <p style={{ fontSize: "1em", fontWeight: 600, color: "orangered", fontFamily: "Poppins" }}>LORD PADAMPRABHU JI</p>
            <p style={{ fontSize: ".8em", fontWeight: 500, color: "#1f5156", fontFamily: "Poppins" }}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(aboutData?.About_Brief) }}></p>

            <p style={{ fontSize: "1em", fontWeight: 600, color: "orangered", fontFamily: "Poppins" }}>ORIGIN OF STATUE</p>
            <p style={{ fontSize: ".8em", fontWeight: 500, color: "#1f5156", fontFamily: "Poppins" }}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(aboutData?.OriginOfStatue) }}></p>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-12'>
            <p style={{ fontSize: ".8em", fontWeight: 500, color: "#1f5156", fontFamily: "Poppins" }}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(aboutData?.ShortAboutSummary) }}></p>
          </div>
        </div>
      </div>

      <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop}
        style={{ width: 40, height: 40, backgroundColor: "red", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <IoArrowUpCircleOutline style={{ fontSize: 40 }} />
      </button>

      <div className=''>
      <button className='Eventbutton mx-auto mt-3'onClick={()=>{navigate(`/Events`)}}>UpComeing Event</button>
      </div>
    </div>
  );
}
